<template>
    <div class="home" :style="{ minHeight: bodyHeight + 'px' }">
        <div class="gContent" :style="{ minHeight: (bodyHeight - 256) + 'px' }">
            <div class="chance-detail">
                <div class="mb-layout" id="app">
                    <div class="mb-content">

                        <div class="demand-info-mian clear">
                            <div class="info-left">
                                <div class="left-top clear">
                                    <div class="top-title "
                                        style="display: flex;justify-content: space-between;margin-top:6px">
                                        <div>
                                            <div style="display: flex;">
                                                <div class="logo" style="margin-right: 10px;">
                                                    <img :src="dataInfo.headImg"
                                                        style="border-radius: 50%;width: 60px;height: 60px; margin-top: 5px;"
                                                        v-if="dataInfo.headImg">
                                                    <img src="https://www.cmef.com.cn/Content/images/cmef-demand-logo.png"
                                                        style="border-radius: 50%;width: 60px;height: 60px;" v-else />
                                                </div>
                                                <div>
                                                    <div>
                                                        <span class="name" style="color: #333333;margin-right: 5px;">{{
                                                            dataInfo.name
                                                            }}</span>
                                                        <span class="job" v-if="dataInfo.jobTitle">{{ dataInfo.jobTitle
                                                            }}</span>
                                                    </div>


                                                    <div class="info2" style="display: flex;max-width:400px;">
                                                        <span class="rn-type" v-if="dataInfo.publishType == '医疗器械成品'"
                                                            style="color:#EE1c5D;margin-right: 10px;">{{ dataInfo.publishType }}</span>
                                                        <span class="rn-type"
                                                            v-if="(dataInfo.publishType == '医疗器械成品' && dataInfo.productType) || (dataInfo.publishType == '医疗器械成品' && dataInfo.type2)"
                                                            style="color:#16D1D1;max-width: 60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                            <span v-if="dataInfo.productType || dataInfo.type2">{{
                                                                dataInfo.productType ? dataInfo.productType :
                                                                dataInfo.type2 }}</span>
                                                        </span>
                                                        <span class="rn-type" v-if="dataInfo.publishType == '制造供应链'"
                                                            style="color:#EE1c5D">{{ dataInfo.publishType }}</span>
                                                        <span class="rn-type"
                                                            v-if="(dataInfo.publishType == '制造供应链' && dataInfo.productType) || (dataInfo.publishType == '制造供应链' && dataInfo.type2)"
                                                            style="color:#16D1D1;max-width: 60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                            <span v-if="dataInfo.productType || dataInfo.type2">{{
                                                                dataInfo.productType ? dataInfo.productType :
                                                                dataInfo.type2 }}</span>

                                                        </span>
                                                        <span class="rn-type" v-if="dataInfo.publishType == '招商发布'"
                                                            style="color:#EE1c5D">{{ dataInfo.publishType }}</span>

                                                        <span class="rn-type"
                                                            v-if="(dataInfo.publishType == '招商发布' && dataInfo.supplyProductName) || (dataInfo.publishType == '招商发布' && dataInfo.information)"
                                                            style="color:#16D1D1;max-width: 60%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                            <span
                                                                v-if="dataInfo.supplyProductName || dataInfo.information">{{
                                                                dataInfo.supplyProductName ? dataInfo.supplyProductName
                                                                : dataInfo.information }}
                                                            </span>
                                                        </span>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                        <span style="margin-top: 20px;">browse：{{ num }}</span>
                                    </div>
                                    <div class="btn-wrap ">
                                        <!-- <div class="btn" id="appletcode1">
                                            <span>关注</span>
                                        </div> -->
                                        <div class="btn" @click='negotiation'>Seeking business cooperation</div>
                                    </div>
                                </div>
                                <div class="info-con">
                                    <div>
                                        <div class="item_bottom" style="font-size: 14px;">
                                            <div class="daili marTop15">
                                                <span class="span1"
                                                    v-if="dataInfo.publishType == '医疗器械成品' || dataInfo.publishType == '制造供应链'">
                                                    <span class="color9">Purchase deadline：</span>
                                                    {{ dataInfo.endTime }}
                                                </span>
                                                <span class="span1" v-else>
                                                    <span class="color9">source：</span>
                                                    {{ dataInfo.companyName ? dataInfo.companyName : "无" }}
                                                </span>
                                            </div>
                                            <div class="daili marTop15"
                                                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                <span class="span2">
                                                    <span class="color9"
                                                        v-if="dataInfo.publishType == '医疗器械成品' || dataInfo.publishType == '制造供应链'">Purchase
                                                        Description：</span>
                                                    <span class="color9" v-else>Release time：{{ dataInfo.inDate
                                                        }}</span>
                                                </span>
                                            </div>
                                            <div
                                                style="padding: 15px;background-color: #f5f5f5;border-radius: 5px;margin-top:20px">
                                                <span
                                                    v-if="dataInfo.publishType == '医疗器械成品' || dataInfo.publishType == '制造供应链'">
                                                    {{ dataInfo.remark }}</span>

                                                <div class="disFlex marTop15 "
                                                    v-if="dataInfo.publishType == '医疗器械成品' || dataInfo.publishType == '制造供应链'">
                                                    <p class="divWidth color9">Purchase quantity</p>
                                                    <p> {{ dataInfo.needCount ? dataInfo.needCount : '无' }}</p>
                                                </div>
                                                <div class="disFlex marTop15 " v-if="dataInfo.publishType == '医疗器械成品'">
                                                    <p class="divWidth color9">Delivery Area</p>
                                                    <p> {{ dataInfo.productArea ? dataInfo.productArea : '无' }}</p>
                                                </div>
                                                <div class="disFlex marTop15 " v-if="dataInfo.publishType == '制造供应链'">
                                                    <p class="divWidth color9">Supplier's location</p>
                                                    <p> {{ dataInfo.productArea ? dataInfo.productArea : '无' }}</p>
                                                </div>
                                                <div class="disFlex marTop15 "
                                                    v-if="dataInfo.publishType == '医疗器械成品' || dataInfo.publishType == '制造供应链'">
                                                    <p class="divWidth color9">Qualification requirements</p>
                                                    <p> {{ dataInfo.condition ? dataInfo.condition : '无' }}</p>
                                                </div>
                                                <div class="disFlex marTop15 " v-if="dataInfo.publishType == '制造供应链'">
                                                    <p class="divWidth color9">Experience requirements</p>
                                                    <p> {{ dataInfo.experience ? dataInfo.experience : '无' }}</p>
                                                </div>
                                                <div class="disFlex marTop15 " v-if="dataInfo.publishType == '制造供应链'">
                                                    <p class="divWidth color9">Payment requirements</p>
                                                    <p> {{ dataInfo.payType ? dataInfo.payType : '无' }}</p>
                                                </div>

                                                <div v-if="dataInfo.publishType == '招商发布' && dataInfo.fromType == 0">
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Investment category</p>
                                                        <p> {{ dataInfo.idnentityType ? dataInfo.idnentityType : '无'
                                                            }}
                                                        </p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Investment regions</p>
                                                        <p> {{ dataInfo.productArea ? dataInfo.productArea : '无' }}
                                                        </p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Supply cycle</p>
                                                        <p> {{ dataInfo.supplyDate ? dataInfo.supplyDate : '无' }}
                                                        </p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Supply quantity</p>
                                                        <p> {{ dataInfo.supplyCount ? dataInfo.supplyCount : '无' }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div v-if="dataInfo.publishType == '招商发布' && dataInfo.fromType == 1">
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Investment Promotion Company</p>
                                                        <p> {{ dataInfo.companyName ? dataInfo.companyName : '无' }}
                                                        </p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Product name</p>
                                                        <p> {{ dataInfo.personProdcutName ?
                                                            dataInfo.personProdcutName : '无' }}
                                                        </p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Product Introduction</p>
                                                        <p> {{ dataInfo.personProductIntroduction ?
                                                            dataInfo.personProductIntroduction : '无' }}</p>
                                                    </div>
                                                    <div class="disFlex marTop15 ">
                                                        <p class="divWidth color9">Product images</p>
                                                        <p> <img :src="dataInfo.personProductImg" alt=""
                                                                style="width: 160px;height:100%"></p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="info-right">
                                <div class="right-wrap">
                                    <div class="right-item">
                                        <img src="https://www.cmef.com.cn/Content/images/cmef-demand-logo.png"
                                            style="width:96px;height:96px" />
                                        <p>CMEF</p>
                                        <span class="link" @click="modal2 = true">CUSTOMER SERVICE</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <!-- <div id="link-modal2" style="display:none;">
                        <p class="kf-title">微信扫码</p>
                        <div class="img-box">

                            <p class="img-box-p">微信扫描 查看详情 </p>
                        </div>
                    </div> -->
                </div>

            </div>
        </div>


        <iModal style="width: 600px;" v-model="modal2" title="CUSTOMER SERVICE" class-name="vertical-center-modal"
            :footer-hide="true">
            <div style="margin-bottom:20px;text-align:center;margin-top: 20px;">
                <img src="https://www.cmef.com.cn/Content/images/cmef-demand-serve.jpeg"
                    style="width:205px;height:205px" />
                <p style="font-size: 18px;margin-top: 20px;">Scan the code to add customer service WeChat</p>
            </div>
            <div class="button" @click="modal2 = false">
                OK
            </div>
        </iModal>


        <!--  洽谈弹窗 -->
        <iModal v-model="isInfoPopup" title="Negotiation" :z-index="1010" class-name="collect-modal myModel"
            width="858">
            <div style="padding: 40px;">
                <Form ref="formAuth" :model="formAuth" :rules="rules_auth" :label-width="120">
                    <FormItem prop="">
                        <h3>Are you sure to send your contact information to the other party?</h3>
                    </FormItem>
                    <FormItem label="Name" prop="linkMan">
                        <Input v-model="formAuth.linkMan" placeholder="Enter your name"></Input>
                    </FormItem>
                    <FormItem label="Email" prop="email">
                        <Input v-model="formAuth.email" placeholder="Enter your email" maxlength=50></Input>
                    </FormItem>
                </Form>

            </div>
            <div slot="footer">
                <Button type="" @click="resetForm_login('formAuth')">cancel</Button>
                <Button type="primary" @click="submitForm_login('formAuth')">ok</Button>
            </div>
        </iModal>


        <!-- 展商洽谈采购 -->
        <iModal v-model="exhibitorsNegotiateProcurementDialog" title="洽谈" class-name="collect-modal myModel"
            width="858">
            <div style="padding: 40px;">
                <div style="margin: 0 40px 0 0;">
                    <h3>发送洽谈成功，请前往展商中心查看。</h3>
                </div>
            </div>
            <div slot="footer">
                <Button type="" @click="exhibitorsNegotiateProcurementDialog = false">取消</Button>
                <Button type="primary" @click="goToTheExhibitorCenter('formAuth')">确认</Button>
            </div>
        </iModal>

        <!-- 将方式发送给对方 开启洽谈 -->
        <iModal v-model="sendItToTheOtherPartyToStartTheNegotiation" title="洽谈" class-name="collect-modal myModel"
            width="858">
            <div style="padding: 40px;">
                <div style="margin: 0 40px 0 0;">
                    <h3>您是否要将联系方式发送给对方，开启洽谈？</h3>
                </div>
            </div>
            <div slot="footer">
                <Button type="" @click="sendItToTheOtherPartyToStartTheNegotiation = false">取消</Button>
                <Button type="primary" @click="goToTheExhibitorCenter('formAuth')">确认</Button>
            </div>
        </iModal>


    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from 'axios'

export default {
    name: "chance-details",
    data () {
        return {
            imgArr: [],
            likeList: [], // 所有点赞人数
            loadState: 1, // 1待加载 2加载中 3全部加载完成
            prodData: [],
            cardData: {},
            TotalPage: 1, // 页总数
            PageIndex: 1, // 当前页
            PageSize: 20, // 当前页
            msgTotal: 0, // 所有留言人数
            codeData: null,
            exData: null,
            erweimaFlag: false, // 点赞二维码弹窗

            chanceMsg: null,
            commentsList: null,
            bodyHeight: "800px",
            hasCollect: 0,
            supplyOpen: false,
            show: false,

            dataInfo: {},
            num: 0,
            modal2: false,

            formAuth: {
                linkMan: "",
                email: "",

            },
            rules_auth: {
                linkMan: [
                    { required: true, message: 'Enter your name', trigger: 'blue' },
                ],
                email: [
                    { required: true, message: 'Enter your email', trigger: 'blue' },
                ],
            },
            typeIndex:0,
            isInfoPopup: false,
            exhibitorsNegotiateProcurementDialog: false,
            sendItToTheOtherPartyToStartTheNegotiation: false,

        };
    },
    components: {

    },
    created () {
        this.bodyHeight = window.innerHeight ? window.innerHeight : "800";

        this.init();
    },

    computed: {
        ...mapGetters({
            exhibitionId: 'getExhibitionId',
            user: "getUser",
            chanceCollectId: "getChanceCollectId"
        }),
        chanceId () {
            return this.$route.query.id;
        },
        logintype () {
            return this.$route.query.logintype;
        },

        compIdEx () {
            return sessionStorage.getItem('compId')
        },
    },
    methods: {
        ...mapMutations({
            setChanceCollectId: "setChanceCollectId"
        }),
        ...mapActions({
            getGxDetails: 'home/getGxDetails',
            getGxDetailsNum: 'home/getGxDetailsNum',
        }),

        async init () {
            let count = await this.getGxDetailsNum(this.chanceId);
            this.num = count.viewCount

            let e = await this.getGxDetails(this.chanceId);
            e.inTime = e.inTime.substring(0, 10)
            e.inDate = e.inDate.substring(0, 10)
            e.endTime = e.endTime ? e.endTime.substring(0, 10) : '无'
            e.productArea = e.productArea ? (JSON.parse(e.productArea).toString()).replace(/,/g, '/') : ''

            const categoryArr = []
            const categoryArr1 = []

            if (e.productType) {
                const category = JSON.parse(e.productType)
                if (category.Value) {
                    categoryArr.push(category.Value)
                    if (category.List[0]) {
                        categoryArr.push(category.List[0].Value)
                        if (category.List[0].List) {
                            categoryArr.push(category.List[0].List[0].Value)
                        }
                    }
                    e.productType = (categoryArr.toString()).replace(/,/g, '/')
                }
            }
            if (e.supplyProductCategory) {
                const category1 = JSON.parse(e.supplyProductCategory)
                if (category1.Value) {
                    categoryArr1.push(category1.Value)
                    if (category1.List[0]) {
                        categoryArr1.push(category1.List[0].Value)
                        if (category1.List[0].List) {
                            categoryArr1.push(category1.List[0].List[0].Value)
                        }
                    }
                    e.supplyProductCategory = (categoryArr1.toString()).replace(/,/g, '/')
                }
            }
            console.log(categoryArr.toString(), typeof categoryArr.toString())
            this.dataInfo = e
            console.log(this.dataInfo, 'dataInfo');
        },

        //   @* 发起洽谈  dataInfo * @
        negotiation () {
            // @* 我是展商 : * @
            if (this.logintype == '展商') {
                if (this.dataInfo.publishType == '招商发布') {
                    this.isInfoPopup = true
                } else {
                    this.isInfoPopup = true
                    this.typeIndex = 3
                }
            } else {
                if (this.dataInfo.publishType == '招商发布') {
                    this.isInfoPopup = true
                } else {
                    // 弹窗回显信息
                    this.formAuth.linkMan = this.user.name || this.user.nickName
                    this.formAuth.email = this.user.email
                    this.isInfoPopup = true
                    this.typeIndex = 4
                }
            }
        },

        noExhibitorsNegotiatePurchasingIndividuals () {
            let personData = {
                companyName: this.user.compName,
                linkMan: this.formAuth.linkMan,
                mob: this.formAuth.email,
                title: this.user.jobTitle,
                headPortrait: this.user.headImgUrl,
                email: this.formAuth.email,
            }
            this.noExSub(personData)
        },

        // 个人和展商身份发起采购洽谈的时候，也要加上手机号输入的弹窗
        async exhibitorsNegotiateProcurementPopUpWindow () {

            let personData = {
                linkMan: this.formAuth.linkMan,
                email: this.formAuth.email,
                mob: this.formAuth.email,
            }
                            
            let body = {
                exhibitionId: this.dataInfo.exhibitionId,
                sourceId: this.compIdEx,//展商id
                productName: '',
                releaseId: this.dataInfo.id,
                linkPerson: JSON.stringify(personData),
                status: 1,
            }

            let array = []
            array.push(body)
            //从供需详情过来的 （非招商发布）  需要请求下面接口  关联子表  再跳转
            axios.post('https://api.cmef.com.cn/api/ReleaseRelevancy/listAdd',
                JSON.stringify(array),
                {
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                },
            )
                .then((res) => {
                    console.log(res, ';;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;')
                    if (res.data.successed) {
                        // this.$Message.success('洽谈发起成功！请前往展商中心查看');
                        this.$Message.success('Negotiation initiated successfully! Please go to the exhibitor center to check');
                        // this.exhibitorsNegotiateProcurementDialog = true
                    } else {
                        // 此数据已关联过，无需重复关联
                        this.$Message.warning('This data has already been associated, there is no need to associate it again');

                    }
                    console.log(res)
                })
        },


        async submitForm_login (formName) {
            let valid = await this.validForm(formName);
            if (!valid) return;

            if (this.typeIndex == 3) {
                this.exhibitorsNegotiateProcurementPopUpWindow()
                this.isInfoPopup = false
                return
            }
            if (this.typeIndex == 4) {
                this.noExhibitorsNegotiatePurchasingIndividuals()
                this.isInfoPopup = false
                return
            }


            let personData = {
                linkMan: this.formAuth.linkMan,
                email: this.formAuth.email,
                mob: this.formAuth.email,
                
            }
            this.noExSub(personData)
        },

        // 展商 个人 都用这个提交
        noExSub (personData) {

            let body = {
                exhibitionId: this.dataInfo.exhibitionId,
                sourceId: this.logintype == '展商' ? this.compIdEx : this.user.id,
                productName: '',
                releaseId: this.dataInfo.id,
                linkPerson: JSON.stringify(personData),
                status: 2,
            }
            //从供需详情过来的 （招商发布）  需要请求下面接口  关联子表  再跳转
            axios.post('https://api.cmef.com.cn/api/ReleaseRelevancy', body).then((res) => {
                if (res) {
                    this.$Message.success('Negotiation initiated successfully! Please go to the exhibitor center to check');
                    // this.sendItToTheOtherPartyToStartTheNegotiation = true
                    this.isInfoPopup = false
                }
                console.log(res)
            })
        },

        goToTheExhibitorCenter () {
            this.sendItToTheOtherPartyToStartTheNegotiation = false
            this.exhibitorsNegotiateProcurementDialog = false
        },


        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid)
                })
            })
        },

        resetForm_login (formName) {
            this.$refs[formName].resetFields();
            this.isInfoPopup = false
        },



    },
};
</script>

<style scoped lang='scss'>
@import "@/assets/scss/utils.scss";

.home {
    background: #f5f5f5;
}

.gContent {
    background: #f5f5f5;
    width: 1200px;
    margin: 0 auto;
}

.chance-detail {
    padding-bottom: 60px;
}

.top-title {
    height: 50px;
    font-size: 14px;
    line-height: 35px;

    &-link {
        color: #999;
    }
}

.main {
    width: 1200px;
    @include clearfix;

    .section {
        width: 878px;
        // box-shadow: 0px 1px 3px 0px rgba(95, 99, 104, 0.1);
        border-radius: 2px;
        background-color: #fff;
        float: left;
        padding-bottom: 40px;

        .title div {
            width: 64%;
            height: 100%;
            float: left;
        }

        .title {
            height: 88px;
            border-bottom: 1px solid #f5f5f5;

            .title-btn {
                width: 36%;
                display: flex;
                align-items: center;
                padding-left: 20px;
            }
        }

        .title h2 {
            font-size: 24px;
            color: #222222;
            float: left;
            margin-top: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 85%;
        }

        .title em {
            font-style: normal;
            font-size: 16px;
            color: #666;
            font-weight: 500;
            margin-left: 10px;
            // float: left;
            // margin-top: 28px;
        }

        .title span {
            float: left;
            font-size: 14px;
            color: #999;
            line-height: 1.5em;
            margin-top: 33px;
        }

        .swiper .container {
            width: 100%;
            margin: 25px 0 0 20px;
        }

        .container2 {
            width: 100%;
            margin: 25px 0 0 20px;
        }

        .container2 p {
            font-size: 16px;
            color: #222222;
            line-height: 30px;
            margin-top: 40px;
            text-align: justify;
            word-break: break-all;
        }

        .fabulous {
            height: 130px;
            text-align: center;
            margin-top: 50px;
        }

        .fabulous div {
            display: inline-block;
            width: 220px;
            height: 77px;
            border-radius: 38px;
            border: solid 2px #e6e6e6;
            text-align: center;
            line-height: 77px;
            font-size: 20px;
            color: #222222;
            cursor: pointer;

            span {
                position: relative;
                top: -5px;
            }

            .icon-liuyan4 {
                position: relative;
                top: 3px;
            }
        }

        .more {
            height: 80px;
            text-align: center;
        }

        .more span {
            color: #040000;
            font-size: 14px;
            cursor: pointer;
            line-height: 80px;
        }

        .icon {
            width: 1em;
            height: 1em;
            vertical-align: 0em;
            fill: currentColor;
            overflow: hidden;
            margin-right: 5px;
            font-size: 30px;
        }
    }

    .sidebar {
        width: 300px;
        float: right;
    }
}

.pic-content {
    font-size: 0;
    padding: 25px;

    img {
        width: 100%;
    }
}


.demand-info-mian {
    min-height: 800px;
}

.demand-info-mian .info-left {
    float: left;
    width: 878px;
    // box-shadow: rgb(95 99 104 / 10%) 0px 1px 3px 0px;
    border-radius: 2px;
    background-color: rgb(255, 255, 255);
}

.demand-info-mian .info-right {
    width: 300px;
    float: right;
}

.demand-info-mian .info-left .left-top {
    height: 88px;
    border-bottom: 1px solid #f5f5f5;
}

.demand-info-mian .info-left .left-top .top-title {
    padding-left: 20px;
    width: 65%;
    height: 100%;
    float: left;
}

.demand-info-mian .info-left .left-top .top-title h2 {
    font-size: 24px;
    color: #222;
    float: left;
    margin-top: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 90%;
}

.demand-info-mian .info-left .left-top .top-title h2 em {
    font-style: normal;
    font-size: 16px;
    color: #666;
    font-weight: 500;
    margin-left: 10px;
}

.demand-info-mian .info-left .left-top .top-title span {

    color: #999;


}

.demand-info-mian .info-left .left-top .btn-wrap {
    width: 35%;
    padding-left: 20px;
    float: left;
    margin-top: 24px;
    display: flex;
}

.demand-info-mian .info-left .left-top .btn-wrap .btn {
    height: 37px;
    line-height: 35px;
    font-size: 14px;
    text-align: center;
    padding: 0 15px;
    box-sizing: border-box;
    border: 1px solid #16D1D1;
    border-radius: 5px;
}

.demand-info-mian .info-left .left-top .btn-wrap .btn:first-child {
    margin-right: 20px;
    border-color: #EE1c5D;
}

.demand-info-mian .info-left .info-con {
    padding: 20px;
    box-sizing: border-box;
}

.demand-info-mian .info-left .info-con .swiper-wrap {
    width: 100%;
    height: auto;
}

.demand-info-mian .info-left .info-con .swiper-wrap .swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
}

.demand-info-mian .info-left .info-con .swiper-wrap .swiper-wrapper .swiper-slide {
    height: auto !important;
}

.demand-info-mian .info-left .info-con .swiper-wrap .swiper-wrapper .swiper-slide img {
    width: 100%;
}


.right-item {
    min-height: 215px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 30px;
    background-color: #fff;
    text-align: center;
}

.right-item img {
    width: 96px;
    height: 96px;
    margin-top: 40px;
}

.right-item p {
    font-size: 18px;
    color: #222;
    margin-top: 20px;
    font-weight: 600;
}

.right-item .link {
    text-align: center;
    margin-top: 20px;
    display: inline-block;
    width: 220px;
    height: 36px;
    background-color: #16D1D1;
    border-radius: 4px;
    font-size: 14px;
    line-height: 36px;
    color: #fff;
    cursor: pointer;
    user-select: none;
}


.item_top {
    color: #333;
    display: flex;
}

.line {
    display: flex;
    align-items: flex-end;
    margin-bottom: 0.16rem;

}

.name {

    font-weight: 400;

}

.job {
    font-size: 12px;
    color: #666;
}

.phone {
    font-size: 14px;
    color: #333;
}

.info2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rn-type {
    display: inline-block;
    font-size: 14px;
    padding: 0px 5px;

    height: 25px;
    line-height: 25px;

    margin-bottom: 12px;
    border-width: 1px;
    border-style: solid;
}

.color9 {
    color: #999999;
}

.marTop15 {
    margin-top: 15px;
}

.divWidth {
    width: 25%;
}

.disFlex {
    display: flex;
}

.button {
    width: 120px;
    height: 40px;
    background-color: #16D1D1;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px auto;
    margin-bottom: 0;
    cursor: pointer;
}
</style>
<style lang="scss">
.ivu-message {
    z-index: 1050 !important;
}
</style>